import { ProductTypesListDataResponse } from '@entities/product/api/product-types';
import { ProductTypeCode } from '@shared/model/product';

export const checkProductTypeIsLicense = (typeId?: string, productTypesList?: ProductTypesListDataResponse) =>
    productTypesList?.items.find((type) => typeId === String(type.id))?.code === ProductTypeCode.License;
